const SLIDE_ITEM_OFFSET_PERCENTAGE = 100;
const SLIDE_ITEM_GAP_PX = 16;
const ANIMATE_SLIDE_INDEX_OFFSET = 1;

interface Style {
	[key: string]: string | number;
}

export const extractAnimationDuration = (animationTiming: string): number | null => {
	const regex = /^(\d+)/;
	const result = regex.exec(animationTiming);

	return result ? Number(result[1]) : null;
};

export const getAnimateSlideIndex = (currentSlideIndex: number, slidesLength: number, toLeft: boolean): number => {
	const firstSlideIndex = 0;
	const lastSlideIndex = slidesLength - 1;

	if (toLeft) {
		return currentSlideIndex === firstSlideIndex
			? slidesLength + ANIMATE_SLIDE_INDEX_OFFSET
			: currentSlideIndex + ANIMATE_SLIDE_INDEX_OFFSET;
	} else {
		return currentSlideIndex === lastSlideIndex ? firstSlideIndex : currentSlideIndex + ANIMATE_SLIDE_INDEX_OFFSET;
	}
};

export const getCarouselStyle = (
	currentSlideIndex: number,
	slidesLength: number,
	animationTiming: string,
	toLeft: boolean,
	movement = 0
): { animateStyle: Style; staticStyle: Style } => {
	const animateSlideIndex = getAnimateSlideIndex(currentSlideIndex, slidesLength, toLeft);
	const totalOffset = animateSlideIndex * SLIDE_ITEM_OFFSET_PERCENTAGE;
	const totalGap = animateSlideIndex * SLIDE_ITEM_GAP_PX;

	// when slide is moving from the last to the first, or vice versa
	if (animateSlideIndex !== currentSlideIndex + ANIMATE_SLIDE_INDEX_OFFSET) {
		return {
			animateStyle: {
				transform: `translateX(calc(-${totalOffset}% - ${totalGap}px))`,
				transition: animationTiming,
			},
			staticStyle: {
				transform: toLeft
					? `translateX(calc(-${SLIDE_ITEM_OFFSET_PERCENTAGE}% - ${SLIDE_ITEM_GAP_PX + movement}px))` // go to the first slide
					: `translateX(calc(-${slidesLength * SLIDE_ITEM_OFFSET_PERCENTAGE}% - ${
							slidesLength * SLIDE_ITEM_GAP_PX + movement
					  }px)`, // go to the last slide
			},
		};
	} else {
		return {
			animateStyle: {
				transform: `translateX(calc(-${totalOffset}% - ${totalGap}px))`,
				transition: animationTiming,
			},
			staticStyle: { transform: `translateX(calc(-${totalOffset}% - ${totalGap + movement}px))` },
		};
	}
};

export const isHorizontalMovement = (movement: { x: number; y: number }): boolean =>
	Math.abs(movement.x) > Math.abs(movement.y);
